// extracted by mini-css-extract-plugin
export default {"title":"TabTitle_title__LsXud"};